import Element from './Element';

function Content() {
  return (
    <div className="content">
      <div className="new">
        <h1 className="title">New Content!</h1>
        {Element("https://img.youtube.com/vi/rS50CdTWaSc/mqdefault.jpg","毒して頂戴", "作詞・作曲: なきそ ボーカル: るぅ", "https://www.youtube.com/watch?v=rS50CdTWaSc", true)}
      </div>
      <div className="music">
        <h1 className="title">Music</h1>
        {Element("https://img.youtube.com/vi/nK1iMmH0TqI/mqdefault.jpg", "ボーカルMIX", "歌ってみた動画のMIXを担当したものをまとめています。", `${process.env.PUBLIC_URL}/mix`, false)}
        {Element(`${process.env.PUBLIC_URL}/piano.jpg`, "ピアノ伴奏", "ピアノ伴奏を作成し、演奏したものをまとめています。", `${process.env.PUBLIC_URL}/piano`, false)}
        {Element("https://img.youtube.com/vi/DmNUye5Y53g/mqdefault.jpg", "音ブロック", "Minecraft内で音ブロックを用いて作成した作品をまとめています。", `${process.env.PUBLIC_URL}/noteblock`, false)}
      </div>
      <div className="software">
        {/* <h1 className="title">Programs</h1>
        {Element(`${process.env.PUBLIC_URL}/noimage.png`, "おじさんbot", "入力した文章をおじさん構文に変換するDiscordBotを作成しました。", `${process.env.PUBLIC_URL}/ojisanbot`, false)}
        {Element(`${process.env.PUBLIC_URL}/noimage.png`, "Yoshi Portfolio", "Yoshiが制作した作品をまとめる本サイトです。", `${process.env.PUBLIC_URL}/portfolio`, false)} */}
      </div>
      <div className="others"></div>
      {/* <h1 className="title">Others</h1> */}
    </div>
  );
}

export default Content;
